import React from "react";
import FacingText from "../components/FacingText";
import FoldingPanel from "../panels/FoldingPanel";
import SideStrut from "../components/SideStrut";
import AldoksFrame from "../components/AldoksFrame";
import { useTranslation } from "react-i18next";
import "../i18n";

const Folding3D = ({ isExporting, config, isOpenTrigger, aluminumColor, glassColor, glassColor2}) => {
  let posX = 0, posZ = 0, angleSum = 0;
  const group = [];
  const { t } = useTranslation();
  config.sections.forEach((section, index) => {
    const panelsArray = section.panels;
    const angleRad = (angleSum * Math.PI) / 180;
    const dirX = -Math.cos(angleRad);
    const dirZ = -Math.sin(angleRad);
    const rotation = [0, -angleSum * (Math.PI / 180), 0];

    // Section başlangıç pozisyonu
    const sectionStartX = posX;
    const sectionStartZ = posZ;
    if (index === 0) {
      let heightOfset = config.hasDrapery ? 0.03 : 0;
      group.push(
        <SideStrut
          height={section.size.height}
          position={[posX + 0.02, section.size.height / 2000 + heightOfset, posZ]}
          rotation={rotation}
          config={config}
          almColor={aluminumColor}
        />
      );
    }

    const hasAldoks = section.aldoks && section.aldoks.length > 0;
    const bottomAldoksHeight = hasAldoks
      ? Math.max(
          0,
          ...section.aldoks
            .filter((a) => a.type === "0")
            .map((a) => parseFloat(a.height) || 0)
        ) / 1000
      : 0;

    const topAldoksHeight = hasAldoks
      ? Math.max(
          0,
          ...section.aldoks
            .filter((a) => a.type === "1")
            .map((a) => parseFloat(a.height) || 0)
        ) / 1000
      : 0;

    const labelY = -0.2 - bottomAldoksHeight;

    panelsArray.forEach((panel, pIndex) => {
      const panelWidth = (section.size.width / 1000) / panelsArray.length;
      const panelHeight = section.size.height / 1000;
      const panelOffsetX = posX + dirX * (panelWidth / 2);
      const panelOffsetZ = posZ + dirZ * (panelWidth / 2);
      const label = `P${index + 1}`;

      group.push(
        <React.Fragment key={`panel-${index}-${pIndex}`}>
          <FoldingPanel
            panel={panel}
            panelId={`panel-${index}`}
            index={pIndex}
            panels={panelsArray}
            width={panelWidth}
            height={panelHeight}
            position={[panelOffsetX, 0, panelOffsetZ]}
            rotation={rotation}
            isOpenTrigger={isOpenTrigger}
            config={config}
            aluminumColor={aluminumColor}
            glassColor={glassColor}
            glassColor2={glassColor2}
            isExporting={isExporting}
          />
          
        </React.Fragment>
      );

      (!isExporting && pIndex === 0 && group.push(
        <>
        <FacingText
          position={[posX, labelY+ 0.1, panelOffsetZ]}
          fontSize={0.1}
          color="black"
        >
          {label}
        </FacingText>
        <FacingText
          position={[posX, labelY, panelOffsetZ]}
          fontSize={0.08}
          color="black"
        >
          {section.size.width}x{section.size.height}
        </FacingText>
      </>
      ));

      posX += dirX * panelWidth;
      posZ += dirZ * panelWidth;
    });

    {!isExporting && (group.push(
      <FacingText
        position={[posX, section.size.height / 1000 + 0.2 + topAldoksHeight, posZ]}
        fontSize={0.1}
        color="black"
      >
        {section.angle}°
      </FacingText>
    ));}

    if(section.angle>0){
      angleSum += 180 - section.angle;
    }
   

    if (section.angle == 0) {
      let heightOfset = config.hasDrapery ? 0.03 : 0;
      group.push(
        <SideStrut
          height={section.size.height}
          position={[posX, section.size.height / 2000 + heightOfset, posZ]}
          rotation={rotation}
          config={config}
          almColor={aluminumColor}
        />
      );
    }

    // ALDOKS DOĞRAMA EKLEME (section başlangıcına göre hizalı)
    section.aldoks?.forEach((aldok, i) => {
      if (aldok.type === "0" || aldok.type === "1") {

        const aldokHeight = parseFloat(aldok.height) / 1000;
        const aldokGlassCount = parseInt(aldok.glass_count);
        let aldokPosY = labelY;
        if( aldok.type === "1") {
          aldokPosY = section.size.height / 1000 + 0.093;
        } else {
          aldokPosY += 0.167;
        }

        let aldokWidth = parseFloat(aldok.width) / 1000 ;
        const aldokLeft = aldok.left_space ? parseFloat(aldok.left_space) / 1000  : 0;
        const aldokCenterOffset = aldokLeft + aldokWidth / 2;
        let aldokPosX = sectionStartX + dirX * aldokCenterOffset;
        const aldokPosZ = sectionStartZ + dirZ * aldokCenterOffset;

        if(sectionStartX == 0) {
          aldokPosX += 0.01;
          aldokWidth += 0.07;
        } else if(index == config.sections.length-1){
          aldokWidth += 0.05;
        }

        group.push(
          <AldoksFrame
            key={`aldoks-${index}-${i}`}
            width={aldokWidth}
            height={aldokHeight}
            position={[aldokPosX, aldokPosY, aldokPosZ]}
            rotation={rotation}
            glassCount={aldokGlassCount}
            color={aluminumColor}
            glassColor={glassColor}
            isComposite={aldok.is_composite}
          />
        );
      }
    });
  });

  return (
    <>
      {group}
      {/* İÇ ALAN */}
      {/*<FacingText
        position={[-0.5, 1, -1.5]}
        fontSize={0.2}
        color="green"
        anchorX="center"
        anchorY="middle"
      >
        {(t("inArea"))}
      </FacingText>*/}

      {/* DIŞ ALAN */}
      {/*<FacingText
        position={[-0.5, 1, +1.5]}
        fontSize={0.2}
        color="red"
        anchorX="center"
        anchorY="middle"
      >
        {(t("outArea"))}
      </FacingText>*/}
    </>
  );
};

export default Folding3D;
